import {Amount} from "@/model/amount";
import {HintState, Player} from "@/store/player/types";
import {SkillType} from "@/store/place/types";

export interface MeetState {
    replica: Replica | undefined;
}

export class Replica {
    meetId: number | undefined;
    specialFrontCommand: string | undefined;
    placeId: number | undefined;
    replicaId: string | undefined;
    title: string | undefined;
    mainText: string | undefined;
    bbCode: boolean | undefined;
    atlasId: string | undefined;
    imageId: string | undefined;
    imageComment: string | undefined;
    agitationText: string | undefined;
    player: Player | undefined;
    removePlace: boolean | undefined;
    setDone: boolean | undefined;
    award: Award | undefined;
    answers: Answer[] | undefined;
    toBattle: boolean | undefined;
    closable: boolean | undefined;
    haveScenarioHint: boolean | undefined;
    refreshNavPanel: boolean | undefined;
}

export class Award {
    amount: Amount | undefined;
    experience: number | undefined;
    skillType: SkillType | undefined;
    skillDelta: number | undefined;
    creatureId: string | undefined;
    goodPoints: number | undefined;
    evilPoints: number | undefined;
    tickets: number | undefined;
    atlasId: string | undefined;
    imageId: string | undefined;
    comment: string | undefined;
}

export class Answer {
    id: string | undefined;
    buttonId: string | undefined;
    atlasId: string | undefined;
    imageId: string | undefined;
    creatureId: string | undefined;
    crId: number | undefined;
    text: string | undefined;
    optionalPay: Pay | undefined;
    specialCommand: string | undefined;
    nextReplica: Replica | undefined;
    awardType!: AwardType;
    awardDelta!: number;
    arrow!: boolean;
    script!: string | undefined;
}

export class AnswerRes {
    hintState!: HintState | undefined;
}

export class Pay {
    amount!: Amount;
    overcharge!: number;
}

export enum AwardType {
    GOLD = "GOLD",
    CRYSTAL = "CRYSTAL",
    MITHRIL = "MITHRIL",
    ELIXIR = "ELIXIR",
    SULFUR = "SULFUR",
    ATTACK_FOR_ALL = "ATTACK_FOR_ALL",
    DEFENCE_FOR_ALL = "DEFENCE_FOR_ALL",
    ATTACK_FOR_ONE = "ATTACK_FOR_ONE",
    DEFENCE_FOR_ONE = "DEFENCE_FOR_ONE",
    EXPERIENCE = "EXPERIENCE",
    HEALTH_FOR_ALL = "HEALTH_FOR_ALL",
    HEALTH_FOR_ONE = "HEALTH_FOR_ONE",
    GOOD_POINTS = "GOOD_POINTS",
    EVIL_POINTS = "EVIL_POINTS",
    GOOD_AND_EVIL_POINTS = "GOOD_AND_EVIL_POINTS",
    TICKETS = "TICKETS",
}
